import { render, staticRenderFns } from "./feedbackTrainer.vue?vue&type=template&id=2254f606&scoped=true"
import script from "./feedbackTrainer.vue?vue&type=script&lang=js"
export * from "./feedbackTrainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254f606",
  null
  
)

export default component.exports